export const SEARCH_EXPANDED_WIDTH = 240;
export const SEARCH_COLLAPSED_WIDTH = 140;
export const OVERFLOW_BUTTON_WIDTH = 36;
// Width of the layout switch IconButton (size="small") + SP2 gap (12px).
// Used to account for hidden content during overflow exit calculation.
export const LAYOUT_SWITCH_BUTTON_WIDTH = 48;
